import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'

import { Wallet, WalletTransfer } from './../block/Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data, user, assets_path } = this.props

    return (
      <div
        className='bg-cover bg-center bg-no-repeat pb-[50px]'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container leading-none'>
          <SimpleHeader
            title={`Оплата`}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[8px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[19px] flex items-center justify-center gap-[7px]'>
              Оплата товаров
              <Wallet />
            </div>
            <div className='flex gap-[5px] items-start mb-[5px]'>
              <div className='bg-[#F6F6F6] rounded-[20px] p-[15px] text-center'>
                <div className='text-[18px] font-medium text-black mb-[10px]'>
                  Наличными <span className='text-[#5A91FF]'>(самовывоз)</span>
                </div>
                <div className='text-[14px] font-normal text-[#00000099]'>
                  Получение заказа непосредственно у Продавца
                </div>
              </div>
              <div className='bg-[#F6F6F6] rounded-[20px] p-[15px] text-center'>
                <div className='text-[18px] font-medium text-black mb-[10px]'>
                  Наличными <span className='text-[#5A91FF]'>(курьеру)</span>
                </div>
                <div className='text-[14px] font-normal text-[#00000099]'>
                  По факту получения заказа от курьерской службы.
                </div>
              </div>
            </div>
            <div className='bg-[#F6F6F6] rounded-[20px] p-[15px] text-center'>
              <div className='text-[18px] font-medium text-black mb-[10px]'>
                Оплата банковской картой<br /><span className='text-[#5A91FF]'>Visa, MasterCard, МИР, SberPay или ApplePay/GooglePay</span>
              </div>
              <div className='text-[14px] font-normal text-[#00000099]'>
                По факту получения Товаров, при условии оснащения Курьерской службы мобильными POS-терминалами.
              </div>
            </div>
            <img src={`/${assets_path}/images/payment/paymetods.svg`} alt="Способы оплаты" width={326} height={34} className='w-full h-auto mt-[7px]' />
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center'>
            <div className='text-[18px] font-medium text-black mb-[8px] flex items-center justify-center gap-[7px]'>
              Возврат денежных средств
              <WalletTransfer />
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mb-[15px]'>
              Уплаченных Покупателем через платежную систему на Сайте банковской картой, осуществляется только на ту карту, с которой была произведена оплата, в соответствии с правилами международных платежных систем и действующим законодательством РФ о национальной платежной системе. Сроки возврата денежных средств регулируются банками-эмитентами и не зависят от сервиса Продавца.
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  assets_path: PropTypes.string
}

export default Main